import { FC } from 'react';
import { RiErrorWarningFill, RiCheckboxCircleFill } from '@remixicon/react';
import { QcReviewName } from '../../../types/QualityChecks';
import ButtonSkeleton from '../../atoms/ButtonSkeleton';
import styles from './QcPreviewModeOptions.module.css';
import { translate } from '../../../localization';

type VariantConfiguration = {
  [key in QcReviewName]: {
    icon: JSX.Element | null;
  };
};

const variantConfiguration: VariantConfiguration = {
  [QcReviewName.NEEDS_REVIEW]: {
    icon: <RiErrorWarningFill size={20} color='#FF910A' />,
  },
  [QcReviewName.PASSED]: {
    icon: <RiCheckboxCircleFill size={20} color='#009B5F' />,
  },
  [QcReviewName.NOT_APPLICABLE]: {
    icon: null,
  },
  [QcReviewName.FAILED]: {
    icon: null,
  },
};

type QcPreviewModeOptionsProps = {
  status: QcReviewName;
  title: string;
  description: string;
  onReviewClick: () => void;
};

const QcPreviewModeOptions: FC<QcPreviewModeOptionsProps> = ({
  status,
  title,
  description,
  onReviewClick,
}) => {
  const handleReviewClick = () => {
    onReviewClick();
  };
  return (
    <div className={styles['qc-preview-mode-options']}>
      <div className={styles['qc-preview-mode-options__text-area']}>
        <div className={styles['qc-preview-mode-options__title-area']}>
          <h6 className={styles['qc-preview-mode-options__title']}>{title}</h6>
          {status && variantConfiguration[status].icon}
        </div>
        <p className={styles['qc-preview-mode-options__description']}>
          {description}
        </p>
      </div>
      {status === QcReviewName.NEEDS_REVIEW && (
        <ButtonSkeleton
          className={styles['qc-preview-mode-options__review-btn']}
          onClick={handleReviewClick}
        >
          {translate('common_review')}
        </ButtonSkeleton>
      )}
    </div>
  );
};

export default QcPreviewModeOptions;
